"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatentStatusSchema = exports.PatentTypeSchema = exports.PatentStatus = exports.PatentType = exports.PatentOwner = void 0;
const zod_1 = require("zod");
var PatentOwner;
(function (PatentOwner) {
    PatentOwner["NIPMO"] = "NIPMO";
    PatentOwner["INVENTOR"] = "INVENTOR";
    PatentOwner["ABANDONED"] = "ABANDONED";
})(PatentOwner || (exports.PatentOwner = PatentOwner = {}));
var PatentType;
(function (PatentType) {
    PatentType["PROVISIONAL"] = "PROVISIONAL";
    PatentType["FULL"] = "FULL";
    PatentType["PCT"] = "PCT";
})(PatentType || (exports.PatentType = PatentType = {}));
var PatentStatus;
(function (PatentStatus) {
    PatentStatus["FILED"] = "FILED";
    PatentStatus["GRANTED"] = "GRANTED";
    PatentStatus["ABANDONED"] = "ABANDONED";
    PatentStatus["EXPIRED"] = "EXPIRED";
})(PatentStatus || (exports.PatentStatus = PatentStatus = {}));
/**
 * Zod schema for validating and parsing case action values.
 *
 * - Ensures that a given input is a valid IPType value.
 * - Can be used in request validation (e.g. with ZodValidationPipe in NestJS).
 *
 */
exports.PatentTypeSchema = zod_1.z.nativeEnum(PatentType);
exports.PatentStatusSchema = zod_1.z.nativeEnum(PatentStatus);
